import { useEffect, useRef, useState } from "react";

/**
 * PhotoReveal — envuelve una <img> (o <picture>) para revelarla con:
 *  - cortina diagonal que se retira
 *  - zoom out sutil (1.08 → 1)
 *  - contraste/saturación que sube al final
 * Todo controlado desde CSS (.photo-reveal + data-in). Solo agregamos
 * un IntersectionObserver que activa el estado cuando entra a vista.
 */
export default function PhotoReveal({ children, className = "", rootMargin = "0px 0px -8% 0px" }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold: 0.15, rootMargin }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [rootMargin]);

  return (
    <div ref={ref} className={`photo-reveal ${className}`} data-in={inView ? "1" : "0"}>
      {children}
    </div>
  );
}
